<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
					<v-col cols="12" md="6" lg="6" xl="4" class="mx-0 px-0 mr-md-2 py-lg-0">
						<div class="inputs-container">
                            <alternativeAutocompleteOne
                            :items="suppliers"
                            :valueInput="providerId"
                            :loading="suppliersLoading"
                            :page="suppliersPage"
                            @valueChange="(v) => {providerId = v}"
                            @onChange="(v) => {index()}"
                            @itemsChange="(v) => {suppliers = v}"
                            @lastPageChange="(v) => {lastPage = v}"
                            @pageChange="(v) =>{ suppliersPage = v }"
                            :label="'Proveedor'"
                            @searchSync="trySearch"
                            @onIntersect="onIntersect"
                            :lastPage="lastPage"
                            classesContainer="width-auto"
                        ></alternativeAutocompleteOne>

                         <alternativeAutocompleteOne
                            :items="currencies"
                            :valueInput="selectedCurrency"
                            @valueChange="(v) => {selectedCurrency = v}"
                            @onChange="(v) => {index()}"
                            :label="'Divisa'"
                            classesContainer="width-auto"
                        ></alternativeAutocompleteOne>
                        </div>
					</v-col>

                    <!-- <v-col cols="12" md="3" lg="3" xl="2" class="mx-0 px-0 mr-md-2 py-lg-0 pr-md-10 ">
                       <alternativeAutocompleteOne
                            :items="currencies"
                            :valueInput="selectedCurrency"
                            @valueChange="(v) => {selectedCurrency = v}"
                            @onChange="(v) => {index()}"
                            :label="'Divisa'"
                            classesContainer="width-auto"
                        ></alternativeAutocompleteOne>
                    </v-col> -->
                    
					<v-spacer></v-spacer>
					<v-col  cols="12" md="5" class="mx-0 py-lg-0">
                        <v-row justify="end">
                            <iconButton class="mr-2" :props="corpExportBtnData">
                                <template slot="imgIcon">
                                    <img :src="apartmentIcon" width="24" :class="corpExportBtnData.disabled ? `filter-grey` : `filter-grey-darken-3`">
                                </template>
                            </iconButton>
                            <iconButton :props="pdfBtnData" class="mr-2 mr-md-2 mb-3 mb-md-0">
                                <template slot="imgIcon">
                                    <img :src="pdfIcon" width="24" :class="pdfBtnData.disabled ? `filter-grey` : `filter-grey-darken-3`">
                                </template>
                            </iconButton>
                            <iconButton :props="exportBtnData"></iconButton>
                        </v-row>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="mx-0 px-0">
						<v-card class="index-card">
                            <v-card-title class="body-1 font-weight-bold">
                                <v-col>
                                    <v-row class="primary" justify="space-around">
                                        <!-- <v-col cols="12" sm="3" class="py-1 text-sm-start text-center">
                                            <span>TOTALES</span>
                                        </v-col> -->
                                        <v-col cols="6" md="2" class="py-1 px-0 text-center">
                                            <span class="nowrap caption font-weight-bold">TOTAL 0 - 30</span>
                                            <br>
                                            <table class="mx-auto ">
                                                <tr v-if="selectedCurrency == 'MXN'">
                                                    <td class="text-subtitle-1 font-weight-bold table-line-height " align=RIGHT>{{totalReport30.mxn}}</td>
                                                    <!-- <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=LEFT>MXN</td> -->
                                                </tr>
                                                <tr v-if="selectedCurrency == 'USD'">
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=RIGHT>{{totalReport30.usd}}</td>
                                                    <!-- <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=LEFT>USD</td> -->
                                                </tr>
                                               
                                            </table>
                                        </v-col>
                                        <v-col cols="6" md="2" class="py-1    px-0 text-center">
                                           
                                          
                                            <span class="nowrap caption font-weight-bold">TOTAL 31 - 60</span>
                                            <br>
                                            <table class="mx-auto ">
                                                <tr v-if="selectedCurrency == 'MXN'">
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=RIGHT>{{totalReport60.mxn}}</td>
                                                    <!-- <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=LEFT>MXN</td> -->
                                                </tr>
                                                <tr v-if="selectedCurrency == 'USD'">
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=RIGHT>{{totalReport60.usd}}</td>
                                                    <!-- <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=LEFT>USD</td> -->
                                                </tr>
                                               
                                            </table>
                                            
                                        </v-col>
                                        <v-col cols="6" md="2" class="py-1  px-0 text-center">
                                           
                                            <span class="nowrap caption font-weight-bold">TOTAL 61 - 90</span>
                                            <br>
                                            <table class="mx-auto ">
                                                <tr v-if="selectedCurrency == 'MXN'">
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=RIGHT>{{totalReport90.mxn}}</td>
                                                    <!-- <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=LEFT>MXN</td> -->
                                                </tr>
                                                <tr v-if="selectedCurrency == 'USD'">
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=RIGHT>{{totalReport90.usd}}</td>
                                                    <!-- <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=LEFT>USD</td> -->
                                                </tr>
                                               
                                            </table>
                                            
                                            
                                        </v-col>
                                        <!-- <v-col cols="6" md="2" class="py-1 px-0  text-center">
                                           
                                            <span class="nowrap caption font-weight-bold">TOTAL 90+</span>
                                            <br>
                                            <table class="mx-auto ">
                                                <tr>
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=RIGHT>{{totalReport90plus.mxn}}</td>
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=LEFT>MXN</td>
                                                </tr>
                                                <tr>
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=RIGHT>{{totalReport90plus.usd}}</td>
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=LEFT>USD</td>
                                                </tr>
                                               
                                            </table>
                                            
                                        </v-col> -->

                                        <v-col cols="6" md="2" class="py-1  px-0 text-center">
                                           
                                            <span class="nowrap caption font-weight-bold">ADEUDO TOTAL</span>
                                            <br>
                                            <table class="mx-auto ">
                                                <tr v-if="selectedCurrency == 'MXN'">
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=RIGHT>{{totalReport.mxn}}</td>
                                                    <!-- <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=LEFT>MXN</td> -->
                                                </tr>
                                                <tr v-if="selectedCurrency == 'USD'">
                                                    <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=RIGHT>{{totalReport.usd}}</td>
                                                    <!-- <td class="text-subtitle-1 font-weight-bold nowrap table-line-height" align=LEFT>USD</td> -->
                                                </tr>
                                               
                                            </table>
                                            
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-card-title>
                            <v-card-text >
                                <datatable  :props="tableProps" @methodHandler="method_handler">
                                    <template v-slot:item.billing_date="props">
                                        <span class="body-2">{{ut.globalDateFormat(props.item.billing_date)}}</span>
                                    </template>
                                </datatable>
                            </v-card-text>
                        </v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

     
	</div>
</template>
<script>
import pdfIcon from '../../../assets/pdf_icon_2.svg';
import apartmentIcon from '../../../assets/apartment.svg';
import Utils from '../../../helpers/Utils';
// import debounce from '../../../helpers/debounce';
export default {
    data(){
		return {
            ut: Utils,
            pdfIcon: pdfIcon,
            apartmentIcon:apartmentIcon,
            selectedCurrency: 'MXN',
            options: {},
            total: 10,
			search: '',
            suppliersLoading: false,
            providerId: '',
            suppliers: [],
            lastPage: false,
            suppliersPage: 1,

            timeoutID: null,
            lockSearch: false,
            
            totalReport30: {mxn: '$0.00', usd: '$0.00'},
            totalReport60:{mxn: '$0.00', usd: '$0.00'},
            totalReport90:{mxn: '$0.00', usd: '$0.00'},
            totalReport90plus:{mxn: '$0.00', usd: '$0.00'},
            totalReport:{mxn: '$0.00', usd: '$0.00'},
          
			serverErrors: {},
            actions: [
                {
					name: 'Adjunto',
					icon: {
						color: 'secondary',
						icon: 'mdi-file-document-outline'
					},
					disabled: true,
					type: 'external',   //  method, external, redirect
					action: '',
                    permissions: 'payable_accounts.show'
				},
				{
					name: 'Detalle',
					icon: {
						color: 'secondary',
						icon: 'mdi-information-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'payable_accounts.show'
				},
				
			],
			tableProps: {
				headers: [
					{
						text: 'factura',
						align: 'left',
						value: 'folio',
						
						class: 'table-b-border black--text'
					},
                    {
						text: 'Referencia',
						align: 'left',
						value: 'reference.name',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Cuenta',
						align: 'left',
						value: 'concept',
                        
						class: 'table-b-border black--text'
					},
                    {
						text: 'Estado',
						align: 'center',
                        
						value: 'status',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Fecha',
						align: 'center',
                        
						value: 'billing_date',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Semana',
						align: 'center',
						value: 'week_number',
						class: 'table-b-border black--text'
					},
                    {
						text: '0-30',
						align: 'right',
                        
						value: 'thirty',
						class: 'table-b-border black--text'
					},
                    {
						text: '31-60',
						align: 'right',
                        
						value: 'sixty',
						class: 'table-b-border black--text'
					},
                    {
						text: '61-90',
						align: 'right',
                        
						value: 'ninety',
						class: 'table-b-border black--text'
					},
                    // {
					// 	text: '90+',
					// 	align: 'right',
                        
					// 	value: 'ninetyPlus',
					// 	class: 'table-b-border black--text'
					// },
                    {
						text: 'Detalle',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '10%',
						class: 'table-b-border black--text'
					},
					
				],
				items: [],
				search: '',
				loading: false,
                elevation: '0',
                sortBy: "billing_date",
                sortDesc: true
			},
			
			
            corpExportBtnData: {
                hasTooltip:true,
                customIcon:true,
                tooltip: 'Exportar Corporativo',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-archive-arrow-down",
                iconClass: "",
				to: "",
				block: false,
                loading: false,
                disabled:false,
                click: ()=>{this.corpExport();}
            },

            exportBtnData: {
               hasTooltip:true,
                tooltip: 'Exportar excel',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-microsoft-excel",
                iconClass: "",
				to: "",
				block: false,
                loading: false,
                disabled:true,
                click: ()=>{this.export();}
            },

            pdfBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar PDF',
                customIcon:true,
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                disabled:true,
                text: "Generar pdf",
                icon: "mdi-progress-download",
                iconClass: "",
				to: "",
				block: false,
                loading: false,
                click: ()=>{this.pdf();}
            },

            currencies:[
                {value: "USD", text:"USD"},
                {value: "MXN", text:"MXN"}
            ]





			
		}
	},

    watch: {
        [`providerId`]() {
           this.watchProviderId();
        }
    },
   

	mounted(){
		// this.index();
        //this.getSuppliers();
        // window.addEventListener('resize', this.onResize, { passive: true });
        // this.onResize();
        this.watchProviderId();
	},

    methods: {
        watchProviderId()
        {
            this.pdfBtnData.disabled = true;
            this.exportBtnData.disabled = true;
            this.corpExportBtnData.disabled = true;
            if(this.providerId != "" && this.providerId != null && this.providerId != undefined){
                this.pdfBtnData.disabled = false;
                this.exportBtnData.disabled = false;
                this.corpExportBtnData.disabled = false;
            }
        },
        onResize () {
            
            if(window.innerWidth <= 960){
                this.exportBtnData.block = true;
                this.pdfBtnData.block = true;
                
            }
            else{
                
                this.exportBtnData.block = false;
                this.pdfBtnData.block = false;
            }
        },
        method_handler(object){
            console.log(object);
			this[object.methodName](object.parameters)
		},
        handleOptions(object){
            object.options[`search`] = this.tableProps.search;
			//console.log(object.options);
			this.options = object.options;
			this.index();
		},
        trySearch(val){
           this.getSuppliers(val.search, val.page);
        },
		index() {
            // // console.log(this.$router)
            if(this.providerId == '' || this.providerId == null || this.providerId == undefined)
                return;
			this.tableProps.loading = true;
            this.totalReport30.mxn = this.totalReport30.usd = Utils.currencyFormat(0, '');
            this.totalReport60.mxn = this.totalReport60.usd = Utils.currencyFormat(0, '');
            this.totalReport90.mxn = this.totalReport90.usd = Utils.currencyFormat(0, '');
            //this.totalReport90plus.mxn =  this.totalReport90plus.usd = Utils.currencyFormat(0, '');
            this.totalReport.mxn = this.totalReport.usd = Utils.currencyFormat(0, '');
            this.tableProps.items = [];
           
			//call api
			this.$api.report.reportBalanceDueBySupplier(this.$store.state.business, this.providerId, this.selectedCurrency)
				.then((resp) =>{
					console.log(resp);
                    this.totalReport30.mxn = Utils.currencyFormat(resp.data.summary.thirty.mxn, '');
                    this.totalReport60.mxn = Utils.currencyFormat(resp.data.summary.sixty.mxn, '');
                    this.totalReport90.mxn = Utils.currencyFormat(resp.data.summary.ninety.mxn, '');
                    //this.totalReport90plus.mxn = Utils.currencyFormat(resp.data.summary.ninety_plus.mxn, '');
                    this.totalReport30.usd = Utils.currencyFormat(resp.data.summary.thirty.usd, '');
                    this.totalReport60.usd = Utils.currencyFormat(resp.data.summary.sixty.usd, '');
                    this.totalReport90.usd = Utils.currencyFormat(resp.data.summary.ninety.usd, '');
                    //this.totalReport90plus.usd = Utils.currencyFormat(resp.data.summary.ninety_plus.usd, '');
                    this.totalReport.mxn = Utils.currencyFormat(
                        resp.data.summary.total.mxn, '');
                    this.totalReport.usd = Utils.currencyFormat(
                        resp.data.summary.total.usd, '');

					this.tableProps.items = resp.data.data.map((x) => {
                        x['actions'] = JSON.parse(JSON.stringify(this.actions));

                        if(x.invoice_pdf_path != null && x.invoice_pdf_path != ''){
                            x.actions[0].action = x.invoice_pdf_path;
                            x.actions[0].disabled = false;
                        }

                        x.actions[1].action = { name: 'CXPDetails', params: { slug: x.slug, report: 'report' } }

						x.thirty = x.sixty = x.ninety = x.ninetyPlus = '-';
                        if(x.due_date_in_days <= 30)
                            x.thirty = Utils.currencyFormat(x?.pending_payment??0, x.currency);
                        if(x.due_date_in_days >= 31 && x.due_date_in_days <= 60)
                            x.sixty = Utils.currencyFormat(x?.pending_payment??0, x.currency);
                        if(x.due_date_in_days >= 61)
                            x.ninety = Utils.currencyFormat(x?.pending_payment??0, x.currency);
                        // if(x.due_date_in_days >= 91)
                        //     x.ninetyPlus = Utils.currencyFormat(x?.pending_payment??0, x.currency);

                        x.concept = `${x.concept.name} (${x?.concept?.account?.name??''})`;
                        // x.billing_date = Utils.globalDateFormat(x.billing_date);

						return x;
					});
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
                    this.lockSearch = false;
                    //console.log('finally', this.lockSearch)
				})
			;
           
		},

        getSuppliers(search = '', page = this.suppliersPage)
        {
            
            this.suppliersLoading = true;
            this.$api.supplier.getSelectPastDueBalance(this.$store.state.business, search, page)
                .then((resp) => {
                    this.suppliers = [...this.suppliers, ...resp.data.data];
                    //this.lastPage = false;
                    if(page == resp.data.last_page)
                        this.lastPage = true;
                    if(this.suppliers.length >= 1){
                        //this.providerId = this.suppliers[0].value;
                        this.index();
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.suppliersLoading = false;
                })
            ;
        },
        onIntersect(val)
        {
            console.log(val)
            this.getSuppliers(val.search, val.page);
        },

        export()
        {
            this.exportBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.report.exportReportBalanceDueBySupplier(this.$store.state.business, this.providerId, this.selectedCurrency)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `saldo_proveedor_${this.providerId}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.exportBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },


        pdf()
        {
            this.pdfBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.report.pdfReportBalanceDueBySupplier(this.$store.state.business, this.providerId, this.selectedCurrency)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `saldo_proveedor_${this.providerId}.pdf`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.pdfBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },

        corpExport()
        {
            this.corpExportBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.report.exportCorpReportBalanceDueBySupplier(this.providerId, this.selectedCurrency)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `saldo_proveedor_corporativo_${this.providerId}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.corpExportBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },

    }
}
</script>

<style lang="scss">
    .inputs-container{
        display: flex;
        gap: 5px;
        flex-direction: row;

    }

    @media only screen and (max-width: 959px) {
        .inputs-container {
            flex-direction: column;
        }
    }
</style>